import { motion } from "framer-motion";
import { ShoppingCart, ShoppingBag, MessageCircle, Map } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "./Reveal";

const stats = [
  { icon: ShoppingCart, value: "800+", label: "Pedidos gestionados en Amazon durante el último año" },
  { icon: ShoppingBag, value: "77+", label: "Pedidos en Mercado Libre durante el último año" },
  { icon: MessageCircle, value: "73+", label: "Ventas directas por WhatsApp" },
  { icon: Map, value: "32", label: "Estados de la República Mexicana con cobertura de entrega" },
];

const timeline = [
  { year: "2024", title: "Fundación de eClick México", text: "Nace como especialista en productos electrónicos y soluciones tecnológicas para empresas." },
  { year: "2024", title: "Alianzas estratégicas", text: "Distribuidores autorizados de Samsung, Syscom e Ingram Micro." },
  { year: "2025", title: "Escala en marketplaces", text: "Más de 800 pedidos gestionados en Amazon y 77+ pedidos en Mercado Libre." },
  { year: "2025", title: "Canal B2B directo", text: "Más de 73 ventas directas por WhatsApp con seguimiento comercial dedicado." },
  { year: "2026", title: "Portafolio corporativo retail", text: "Oferta integral para cadenas como OXXO, Walmart, Soriana, Liverpool y más." },
];

export default function About() {
  return (
    <section id="nosotros" className="relative py-24 md:py-36 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          num="01"
          chapter="Nosotros"
          id="nosotros"
          title={<>Especialistas en tecnología <span className="text-ecamber">para empresas</span></>}
          sub="Somos un proveedor nacional de productos electrónicos y soluciones tecnológicas. Operamos con estándares de marketplace y atención B2B de primer nivel."
        />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.value + i} delay={i * 0.08}>
              <div className="card-lift h-full bg-white border border-ecnavy/10 rounded-2xl p-8 soft-shadow" data-testid={`about-stat-${i}`}>
                <span className="icon-tile inline-flex h-12 w-12 rounded-xl bg-ecnavy/5 text-ecnavy items-center justify-center mb-6">
                  <s.icon size={22} strokeWidth={2} />
                </span>
                <p className="font-display text-4xl font-semibold text-ecdeep tracking-tight">{s.value}</p>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24 md:mt-32">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-ecnavy/50 mb-12">Nuestra trayectoria</p>
          </Reveal>
          <div className="relative">
            <div className="absolute left-[7px] md:left-1/2 md:-translate-x-px top-2 bottom-2 w-px bg-ecnavy/10" />
            <div className="space-y-12 md:space-y-16">
              {timeline.map((t, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.8, ease: EASE }}
                  className={`relative flex md:items-center gap-8 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
                  data-testid={`timeline-item-${i}`}
                >
                  <span className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-1.5 h-[15px] w-[15px] rounded-full bg-white border-[3px] border-ecamber shadow-[0_0_0_5px_rgba(245,168,28,0.15)]" />
                  <div className={`ml-10 md:ml-0 md:w-1/2 ${i % 2 === 0 ? "md:pr-16 md:text-right" : "md:pl-16"}`}>
                    <span className="font-display text-sm font-semibold text-ecamber tracking-[0.2em]">{t.year}</span>
                    <h3 className="font-display text-xl font-semibold text-ecdeep mt-2">{t.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed max-w-md md:ml-auto">{t.text}</p>
                  </div>
                  <div className="hidden md:block md:w-1/2" />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
